import { getConfig } from '@superbet-group/web.lib.config';
import {
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';

import { defaultHttpTimeoutMs } from '@core/constants';
import { AllowancesDto } from '@sportOfferFederation/multi-market-select/types';
import { getCmsUrl } from '@core/services/cms/utils';

export default class RestService {
    private readonly restClient: RestClient = createRestClient(
        getCmsUrl({
            path: '/allowances/',
        }),
        defaultHttpTimeoutMs,
    );

    public getAllowances(): Promise<AllowancesDto> {
        return this.restClient.get(getConfig().appLocale.languageCode);
    }

    public getAllowancesV2(): Promise<AllowancesDto> {
        return this.restClient.get('v2');
    }
}
